import React, { Component } from 'react'
import { applyMiddleware, createStore } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import Setup from './Setup'
import rootReducer from '../store'

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore)


export default class App extends Component {
    render() {
        return (
            <Provider store={createStoreWithMiddleware(rootReducer)}>
                <Setup />
            </Provider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/App.js